module.exports = __webpack_public_path__ + "img/7.abac1250.jpg";